"use client";

import styled from "styled-components";
import PropTypes from "prop-types";
import { H5 } from "@churchofjesuschrist/eden-headings";
import { blue30, spacing16, spacing8, white, backgroundColorLevel2, accentColorPrimary, setAppearanceConstantLocal } from "@churchofjesuschrist/eden-style-constants";
import { Regular } from "@churchofjesuschrist/eden-light-rays";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const [headerBackgroundDef, headerBackground] = setAppearanceConstantLocal("workforce-header-background", {
  light: blue30,
  dark: backgroundColorLevel2,
  prefix: "eden"
});
const [headerForegroundDef, headerForeground] = setAppearanceConstantLocal("workforce-header-foreground", {
  light: white,
  dark: accentColorPrimary,
  prefix: "eden"
});
const height = "3rem";
const Header = styled.header.withConfig({
  componentId: "sc-7msvi1-0"
})(["", " ", " display:flex;justify-content:space-between;align-items:center;height:", ";background-color:", ";color:", ";padding-inline-end:", ";"], headerBackgroundDef, headerForegroundDef, height, headerBackground, headerForeground, spacing16);
const MenuButtonWrapper = styled.div.withConfig({
  componentId: "sc-7msvi1-1"
})(["background-color:currentColor;height:100%;display:flex;align-items:center;z-index:1;"]);
const LightRays = styled(Regular).withConfig({
  componentId: "sc-7msvi1-2"
})(["flex:0 0 auto;", " + &{margin-inline-start:-", ";}"], MenuButtonWrapper, spacing8);
const Name = styled(H5).withConfig({
  componentId: "sc-7msvi1-3"
})(["flex:1;margin-inline-start:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;& > a{color:currentColor;text-decoration:none;&:visited,&:active{color:currentColor;}&:hover{color:currentColor;text-decoration:underline;}}"], spacing16);
const Tools = styled.div.withConfig({
  componentId: "sc-7msvi1-4"
})(["display:flex;align-items:center;& a{color:currentColor;text-decoration:none;&:visited,&:active{color:currentColor;}&:hover{color:currentColor;text-decoration:underline;text-decoration-color:currentColor;}}& button{color:currentColor;&:hover{color:currentColor;}}"]);

/** Standard header for workforce applications. */
const WorkforceHeader = _ref => {
  let {
    name,
    menuButton,
    tools,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(Header, {
    ...rest,
    children: [menuButton ? /*#__PURE__*/_jsx(MenuButtonWrapper, {
      children: menuButton
    }) : null, /*#__PURE__*/_jsx(LightRays, {
      origin: "start",
      color: "currentColor"
    }), /*#__PURE__*/_jsx(Name, {
      renderAs: "div",
      children: name
    }), tools ? /*#__PURE__*/_jsx(Tools, {
      children: tools
    }) : null]
  });
};
WorkforceHeader.propTypes = {
  /** The application name. Should be a single `<a>` element containing the application name. */
  name: PropTypes.node.isRequired,
  /** Must be a single `<MenuButton>` element from `eden-workforce-header`. */
  menuButton: PropTypes.element,
  /** Content to put in the tools slot. */
  tools: PropTypes.node
};
export default WorkforceHeader;